"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectInput = exports.NativeSelectInput = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_select_1 = __importStar(require("react-select"));
const label_1 = __importDefault(require("../label"));
const text_1 = __importDefault(require("../text"));
const input_styles_1 = require("./input-styles");
const types_1 = require("../../lib/types");
const utils_1 = require("../../lib/utils");
const theme_1 = __importDefault(require("../../styles/theme"));
const SelectRoot = styled_components_1.default.div `
  display: ${(props) => (props.inline ? 'inline-block' : 'block')};
  width: ${(props) => (props.inline ? 'auto' : '100%')};
`;
const SelectContainer = styled_components_1.default.div `
  ${input_styles_1.inputFieldStyles}
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: ${(props) => (props.inline ? 'auto' : '100%')};
  ${(props) => props.disabled &&
    `
    cursor: default;
  `}
  &:focus-within {
    outline: ${(props) => props.theme.outline};
    outline-offset: 1px;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.23);
  }
  &:hover {
    border: 1px ${theme_1.default.colors.borderDefault} solid;
    box-shadow: none;
  }
`;
const SelectElement = styled_components_1.default.select `
  ${input_styles_1.inputStyles}
  font-family: ${(props) => props.theme.font.family.sans};
  cursor: pointer;
  width: 100%;
  background-repeat: no-repeat;
  background-position-x: 100%;
  ${(props) => props.disabled && `cursor: default;`}
`;
const CustomSelect = styled_components_1.default(react_select_1.default) `
  & .Select__control {
    ${input_styles_1.inputFieldStyles}
    padding: 2px 0px;
    cursor: pointer;
    width: ${(props) => (props.inline ? 'auto' : '100%')};

    ${(props) => props.disabled && 'cursor: default;'}

    &--is-focused {
      outline: ${(props) => props.theme.outline} !important;
      outline-offset: 1px;
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.23);
    }

    &:hover {
      border: 1px ${theme_1.default.colors.borderDefault} solid;
      box-shadow: none;
    }
  }

  & .Select__option--is-focused {
    background-color: ${theme_1.default.colors.backgroundPrimaryAccent};
  }

  & .Select__option--is-selected {
    background-color: ${theme_1.default.colors.primaryAccent};
  }

  ${(props) => props.inline &&
    `
    min-width: max-content;
    width: 100%;

    & .Select__single-value {
      max-width: unset;
      position: unset;
      top: unset;
      transform: unset;
    }

    & .Select__menu {
      width: 100%;
    }
  `}
`;
const CustomControl = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (react_1.default.createElement(react_select_1.components.Control, Object.assign({ "data-testid": "control" }, props), children));
};
const CustomSingleValue = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (react_1.default.createElement(react_select_1.components.SingleValue, Object.assign({ "data-testid": "singlevalue" }, props), children));
};
const CustomOption = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (react_1.default.createElement(react_select_1.components.Option, Object.assign({}, props),
        react_1.default.createElement("div", { role: "option", "aria-selected": props.isSelected, className: "Select__wrapper" }, children)));
};
const NativeSelectInput = ({ className, hint, id, innerRef, inline = false, disabled = false, children, onChange = utils_1.noop, onBlur = utils_1.noop, onFocus = utils_1.noop, onClick = utils_1.noop, value = undefined, name = '', error = false, required = false, label = undefined, ariaLabel = undefined, defaultValue, style, }) => {
    types_1.accessibleLabelCheck(ariaLabel, label);
    return (react_1.default.createElement(SelectRoot, { className: className, inline: inline, style: style },
        label && react_1.default.createElement(label_1.default, { error: error && !hint }, label),
        react_1.default.createElement(SelectContainer, { disabled: disabled, inline: inline, error: error },
            react_1.default.createElement(SelectElement
            // If ariaLabel is not present, then label is a string
            , { "aria-label": ariaLabel || label, id: id, name: name, ref: innerRef, value: value, onChange: onChange, onBlur: onBlur, onFocus: onFocus, onClick: onClick, disabled: disabled, required: required, "aria-required": required, defaultValue: defaultValue, style: {
                    backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${theme_1.default.font.size.m.fontSize}"><path d="M0 0h24v24H0V0z" fill="none"/><path fill="%23${error
                        ? theme_1.default.colors.error.substring(1)
                        : theme_1.default.colors.textInput.substring(1)}" d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/></svg>')`,
                } }, children)),
        hint && (react_1.default.createElement(text_1.default, { fontSize: "xs", fontWeight: "normal", color: error ? theme_1.default.colors.error : theme_1.default.colors.textDefault }, hint))));
};
exports.NativeSelectInput = NativeSelectInput;
const SelectInput = ({ className, hint, id, innerRef, inline = false, disabled = false, children, onChange = utils_1.noop, onBlur = utils_1.noop, onFocus = utils_1.noop, onClick = utils_1.noop, value = undefined, name = '', error = false, label = undefined, ariaLabel = undefined, style, }) => {
    types_1.accessibleLabelCheck(ariaLabel, label);
    const options = [];
    let valueOption;
    react_1.default.Children.map(children, (child) => {
        var _a;
        const childProps = (_a = child) === null || _a === void 0 ? void 0 : _a.props;
        if (childProps.value === value) {
            valueOption = {
                value: childProps.value,
                label: childProps.children,
                isDisabled: childProps.disabled,
            };
        }
        options.push({
            value: childProps.value,
            label: childProps.children,
            isDisabled: childProps.disabled,
        });
    });
    // Extend the raw inner props given by default to pass the onClick() through to the CustomControl
    const createInnerProps = (rawInnerProps) => (Object.assign(Object.assign({}, rawInnerProps), { onClick: (e) => {
            e.preventDefault();
            e.stopPropagation();
            onClick(e);
        } }));
    return (react_1.default.createElement(SelectRoot, { className: className, inline: inline, style: style },
        label && react_1.default.createElement(label_1.default, { error: error && !hint }, label),
        react_1.default.createElement(CustomSelect, { "aria-label": ariaLabel || label, classNamePrefix: "Select", components: {
                Option: (_a) => {
                    var props = __rest(_a, []);
                    return (react_1.default.createElement(CustomOption, Object.assign({}, props)));
                },
                SingleValue: (_a) => {
                    var props = __rest(_a, []);
                    return (react_1.default.createElement(CustomSingleValue, Object.assign({}, props)));
                },
                Control: (_a) => {
                    var { innerProps } = _a, props = __rest(_a, ["innerProps"]);
                    return (react_1.default.createElement(CustomControl, Object.assign({}, props, { innerProps: createInnerProps(innerProps) })));
                },
            }, defaultValue: options[0], inputId: id, inline: inline, innerRef: innerRef, isDisabled: disabled, isSearchable: false, name: name, value: valueOption, onChange: (selectedValue, { action }) => {
                if (action === 'select-option')
                    onChange(selectedValue);
                else if (action === 'remove-value')
                    onChange(selectedValue);
                else if (action === 'clear')
                    onChange(selectedValue);
            }, onBlur: onBlur, onFocus: onFocus, onClick: onClick, disabled: disabled, error: error, options: options }),
        hint && (react_1.default.createElement(text_1.default, { fontSize: "xs", fontWeight: "normal", color: error ? theme_1.default.colors.error : theme_1.default.colors.textDefault }, hint))));
};
exports.SelectInput = SelectInput;
exports.default = exports.SelectInput;
